<template>
  <div class="content">
    <a :href="item.links.content_url" class="w-100 d-block text-center" target="_blank">
      <i class="mobile-bright-blue-button" data-toggle="tooltip">Open PDF</i>  
    </a>
    <iframe ref="pdfViewer" type="application/pdf" :src="item.links.content_url" height="100%" width="100%" frameborder="0" :data-tool="canDownload" style="flex: 1;">
      <p>This browser does not support PDFs.</p>
      <div v-if="canDownload">
        Please download the PDF to view it:
        <a :href="item.links.download_url">Download PDF</a>
      </div>
    </iframe>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
    zoomed: Boolean,
    cta: Object,
    showDownload: Boolean,
    canDownload: Boolean,
  }
}
</script>

<style scoped lang="scss">
@import '../../../packs/application.scss';

div.content {
  height: 80vh;
  width: 100%;
}
</style>
